function StaffDetails() {
  return (
    <div style={{ padding: '20px' }}>
      <h1 className="text-2xl font-bold text-center mb-4">School Staff Details</h1>
      <p className="text-center mt-4">
        <a
          href="/documents/StaffDetails.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xl font-bold text-purple-700 underline hover:text-purple-900"
        >
          CLICK HERE TO SEE THE SCHOOL STAFF LIST
        </a>
      </p>
    </div>
  );
  }
  
  export default StaffDetails;
  